<ca-modal-container [modalTitle]="'UPLOADER.DIALOG_TITLE' | translate" [description]="'UPLOADER.DIALOG_DESCRIPTION' | translate" (dismiss)="dismiss()">
    <ca-file-upload
        [blobType]="blobType"
        [allowMultipleFiles]="false"
        [uploaderKey]="'file_uploader_dialog'"
        [maxInputSizeInBytes]="maxInputSizeInBytes"
        [base64StringToUpload]="base64StringToUpload"
        [showHeader]="false"
        [pathToAppend]="pathToAppend"
        [errorNotificationMode]="'notification'"
        (onUploadCompleted)="fileSuccessfullyUploaded($event)"
        data-uit="file-upload-dialog-input-files-upload"
    ></ca-file-upload>
    <div class="d-flex justify-content-end mt-3" *ngIf="showButtonBar">
        <button type="button" (click)="dismiss()" class="me-2 btn btn-secondary">Cancel</button>
        <button type="button" [disabled]="imageUrl == null" (click)="closeModal()" class="me-2 btn btn-primary">Insert image</button>
    </div>
</ca-modal-container>
